import HCMsettings from '@/config/cosmoMarketing/pages/home/index'

export default {
  data() {
    return {
      gtmSubsection: 'Home',
      gtmSubsection2: '',
      heroConfig: this.$t('pages.home.Hero'),
      exp: this.$experiment.versionOf('hotmart-new-hero-image'),
      positionsConfig: this.$t('pages.home.Positions'),
      countersConfig: this.$t('pages.home.Counters'),
      testimonialsConfig: this.$t('pages.home.Testimonials'),
      socialsConfig: this.$t('components.Socials'),
      faqConfig: this.$t('pages.home.Faqs'),
      /* faqsConfig: {
        settings: HCMsettings.HcmFaqs,
        children: this.$t('pages.home.HcmFaqs'),
      }, */
    }
  },
  created() {
    this.$experiment.init()
  },
}
